import classnames from 'classnames';
import {
  ImageWithAttribution as V3ImageWithAttribution,
  ImageWithAttributionProps,
} from '@stadionhq-v3/base-ui';
import styles from './imageWithAttribution.module.scss';

const ImageWithAttribution = ({ ...props }: ImageWithAttributionProps) => {
  const classes = classnames([
    styles.imageWithAttributionTokens,
    styles.imageWithAttribution,
    styles.default1,
  ]);

  return <V3ImageWithAttribution {...props} classNames={[classes]} />;
};

export default ImageWithAttribution;
